import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';

import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MdPaginator, MdSort } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { IesHttpClient } from '../../Common/ies-http-client.service';
import { Enum } from '../../utility/enum.enum';
import { userRole_globalAdmin } from './../../Common/appConstant';
import { AppUrl } from './../../Common/appUrl';
import { TableDataSource } from './../../Common/md-table';
import { AppGlobals } from './../../Common/Services/app.global';
import { SharedService } from './../../Common/Services/shared.service';
import { Utility } from './../../Common/Services/utility';
import { AdmManageLocationService } from './adm-manage-location.service';


@Component({
  selector: 'app-adm-manage-location',
  templateUrl: './adm-manage-location.component.html',
  styleUrls: ['./adm-manage-location.component.css'],
  providers: [AdmManageLocationService]
})

export class AdmManageLocationComponent implements OnInit {
  @ViewChild(MdPaginator) paginator: MdPaginator;
  @ViewChild(MdSort) sort: MdSort;
  dataSource: TableDataSource | null;
  httpClient: IesHttpClient;
  appUrl = AppUrl;
  remotePaginationParams: any; //params required for remote pagination for search grid
  regionFilteredOptions: any;
  countryFilteredOptions: any;
  locationFilteredOptions: any;
  keyboardTypeFilteredOptions: any;
  regionBasedLocation: any;   //used to retain values of location mapped with region
  isSearchDisable: boolean;
  form: FormGroup;
  formControl: any;
  role: string;
  showField: boolean;
  curPage: number = 2;
  dataSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]); // store all grid data

  paginationInfo: any;
  displayedColumns = ['code', 'locationAddress', 'keyboardType', 'status', 'action'];
  constructor(private _admManageLocationService: AdmManageLocationService, httpClient: IesHttpClient,
    private _sharedService: SharedService, public _utility: Utility, public _appGlobal: AppGlobals) {
    this.httpClient = httpClient;
    this.form = new FormGroup({
      regionControl: new FormControl(''),
      countryControl: new FormControl(''),
      locationControl: new FormControl(''),
      keyboardTypeControl: new FormControl('')
    })

    this.formControl = this.form.controls;
    this.checkPermission();
  }

  /**
   * Check User Role
   * Hide Region field incase of role site admin or regional admin
   */
  checkPermission() {
    this.role = this._utility.getUserRole();
    if (this.role && this.role == userRole_globalAdmin) {
      this.showField = true;
    } else {
      this.showField = false;
    }
  }


  // Request to get all searched Location
  getLocation(params: string) {
    this._utility.addLoaderCount();
    this._admManageLocationService.getSearchedLocation(params).subscribe(response => {
      this._utility.onSuccessCallback(response, null, () => {
        this.paginator.pageIndex = 0;
        this.dataSource.curPage = 2;
        this.dataSubject.next(response.response.results);
        if (response.response.paginationInfo) { this.paginationInfo = response.response.paginationInfo; }// update paginaton info
      })
    }, error => this._utility.onErrorCallback(error));
  }

  //TODO: Here  setTimeout is temp solution to load data
  // There are some thread issue on api side - so need to fix that one
  ngOnInit() {
    this.paginationInfo = { totalRecords: 0 }; // Set initial value of Totalrecords property
    this.loadCombos();

    // Load all locations initially when page load

    this.getLocation("1/?pageSize=100"); // 1 is page size
    this.dataSource = new TableDataSource(this.dataSubject, this.paginator, this.sort, this.httpClient);
    this.readFormControlValueChanges();
  }

  readFormControlValueChanges() {
    this.form.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe(form => {
        this.isSearchDisable = this._utility.searchDisable(form, [], true);
      });

    this.formControl.regionControl.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.regionChanges(value);
      });

    this.formControl.countryControl.valueChanges
      .debounceTime(100)
      .distinctUntilChanged()
      .subscribe((value) => {
        this.countryChages(value);
      });

  }


  /**
   * Load data in Location dropdown & country droddown
   * TO Load data in location we hit request
   * To Load data in country we simply filter at our end
   * @param value - selected region
   */
  regionChanges(value) {
    if (!value) {
      this._utility.setDataInComboField('location', null, this.formControl.locationControl, this); // we have passed second params is null means we are not passing any custom data from here, so it will load all locations
      this._utility.setDataInComboField('country', null, this.formControl.countryControl, this);
      return;
    }
    if (value && value.id) {
      // Here we have to show locations based on selected region
      let param = "?outputType=" + Enum.LocationName + "&id=" + value.id + "&inputType=" + Enum.Region;
      this._sharedService.requestDataForCombo(param).subscribe(response => {
        this._utility.onSuccessCallback(response, null, () => {
          this._utility.setDataInComboField('location', response.response.results, this.formControl.locationControl, this);
          this.regionBasedLocation = response.response.results;
        });
      }, error => this._utility.onErrorCallback(error));
      let data = this._sharedService.countryList.filter(function (item) { if (item.parentId == value.id) return item });
      if (data) {
        this._utility.setDataInComboField('country', data, this.formControl.countryControl, this);
      }
    } else {
      this.locationFilteredOptions = null;
      this.countryFilteredOptions = null;
    }
    this.formControl.countryControl.setValue('');
    this.formControl.locationControl.setValue('');
  }

  // When country value changes, load location field
  countryChages(value: any) {
    //when there is no country selected update location dropdown filtered on the basis of selected region(this.regionBasedLocation)
    if (!value) {
      this._utility.setDataInComboField('location', this.regionBasedLocation, this.formControl.locationControl, this);
      return;
    }
    if (value && value.id) {
      let data = this._sharedService.locationList.filter(function (item) { if (item.parentId == value.id) return item });
      if (data) {
        this._utility.setDataInComboField('location', data, this.formControl.locationControl, this);
      }
    } else {
      this.locationFilteredOptions = null;
    }
    this.formControl.locationControl.setValue('');
  }



  /* Initial Request to Load all data in Search Fields
   * Passed Callback function with each request
   * In Call back function we call another function _utility.setDataInComboField - To set data in fields
  */
  loadCombos(): void {
    this._utility.addLoaderCount();
    this._sharedService.getComboFieldsData(Enum.Region, (response) => {
      this._sharedService.regionList = response.response;
      this._utility.setDataInComboField('region', null, this.formControl.regionControl, this);
      this._utility.removeLoaderCount();
    });

    this._utility.addLoaderCount();
    this._sharedService.getComboFieldsData(Enum.Country, (response) => {
      this._sharedService.countryList = response.response;
      this._utility.setDataInComboField('country', null, this.formControl.countryControl, this);
      this._utility.removeLoaderCount();
    });

    this._utility.addLoaderCount();
    this._sharedService.getComboFieldsData(Enum.LocationName, (response) => {
      this._sharedService.locationList = response.response;
      this._utility.setDataInComboField('location', null, this.formControl.locationControl, this);
      this._utility.removeLoaderCount();
    });

    this._utility.addLoaderCount();
    this._sharedService.getComboFieldsData(Enum.KeyboardType, (response) => {
      this._sharedService.keyboardTypeList = response.response;
      this._utility.setDataInComboField('keyboardType', null, this.formControl.keyboardTypeControl, this);
      this._utility.removeLoaderCount();
    });

    // // Load Combo Fields data which are required for add / Upate Location page

    // Business Center
    this._sharedService.getComboFieldsData(Enum.BusinessCenter, (response) => {
      this._sharedService.businessCenterList = response.response;
    });

    // State
    this._sharedService.getComboFieldsData(Enum.State, (response) => {
      this._sharedService.stateList = response.response;
    });

    // City
    this._sharedService.getComboFieldsData(Enum.City, (response) => {
      this._sharedService.cityList = response.response;
    });

    // group
    this._sharedService.getComboFieldsData(Enum.ProctorGroup, (response) => {
      this._sharedService.proctorGroupList = response.response;
    });

    // timezone
    this._sharedService.getComboFieldsData(Enum.TimeZone, (response) => {
      this._sharedService.timeZoneList = response.response;
    });
  }

  // Set Location status icons based on its value
  getStatusCls(value) {
    try {
      if (value.toLowerCase().trim() == "active") return 'activeStatusCls';
      if (value.toLowerCase().trim() == "retired") return 'retireStatusCls';
      if (value.toLowerCase().trim() == "pending") return 'pendingStatusCls';
    }
    catch (Exception) { }
  }


  /* When we click on search button, this function calls
  *  Based on selected Values - we create params and pass it into getLocation function.
  */
  onSearchBtnClick() {
    let pageNo = "1";
    let params = "";
    let pageSizeParam = "pageSize=100&";
    let formValues = this.form.getRawValue();
    if (formValues.regionControl) {
      params += `regionId=${formValues.regionControl.id}&`;
    }
    if (formValues.countryControl) {
      params += `countryId=${formValues.countryControl.id}&`;
    }
    if (formValues.locationControl) {
      params += `locationId=${formValues.locationControl.id}&`;
    }
    if (formValues.keyboardTypeControl) {
      params += `keyboardTypeId=${formValues.keyboardTypeControl.id}&`;
    }
    this.remotePaginationParams = "?" + pageSizeParam + params.substring(0, params.length - 1);
    params = pageNo + this.remotePaginationParams;
    this.getLocation(params);
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location/adm-manage-location.component.ts